export class CreatePriceAlertResponseModel {
    public created = new Date();
}